export default __webpack_public_path__ + "static/media/Choose3.4013234d.png";